import { render } from "./InformeTipoDanyos.vue?vue&type=template&id=55a33ff1&scoped=true"
import script from "./InformeTipoDanyos.vue?vue&type=script&lang=js"
export * from "./InformeTipoDanyos.vue?vue&type=script&lang=js"

import "./InformeTipoDanyos.vue?vue&type=style&index=0&id=55a33ff1&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a33ff1"]])

export default __exports__